import { useEffect, useMemo, useState } from "react";

import { useGetCreditsAvailableQuery } from "../../features/api/payments";

export default function useBOMUsage() {
  const [maxReached, setMaxReached] = useState(false);
  const { data: creditsAvailable } = useGetCreditsAvailableQuery();
  const qualCreditsAvailable = creditsAvailable?.qualCredits || 0;
  const certCreditsAvailable = creditsAvailable?.certCredits || 0;

  useEffect(() => {
    if (qualCreditsAvailable === 0 && certCreditsAvailable === 0) {
      setMaxReached(true);
    } else {
      setMaxReached(false);
    }

    return () => {
      setMaxReached(false);
    };
  }, [qualCreditsAvailable, certCreditsAvailable]);

  useEffect(() => {
    console.log(creditsAvailable);
  }, [creditsAvailable]);

  return useMemo(
    () => ({
      maxReached,
    }),
    [maxReached],
  );
}
